<div class="reference_body">
  <main class="reference_main">
    <div class="pink_box"></div>
    <div class="green_box"></div>

    <div class="main">

      <div class="container-fluid">

      <div class="gmou">
        <div class="the_header">
          <div class="row">
            <div class="col-md-6">
              <h3 class="header" style="margin-top: 2rem;">Project Detailed Report</h3>
            </div>
            <div class="col-md-6">
              <div class="filter_button pull-right">
                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" color="accent" class="m-3">

                  <mat-button-toggle value="grid" routerLink="/project"><mat-icon class="example-tab-icon">arrow_back</mat-icon> Back</mat-button-toggle>
                  <mat-button-toggle mat-raised-button value="grid" color="primary" (click)="filterProjectModal()"><mat-icon class="example-tab-icon">filter_list</mat-icon> Filter Project</mat-button-toggle>
                </mat-button-toggle-group>
                <!-- <button mat-raised-button color="primary" (click)="filterProjectModal()"> <mat-icon class="example-tab-icon">filter_list</mat-icon> Filter Project</button> -->
               </div>
            </div>
          </div>
        </div>



        <div class="monitor_project_drop">


          <div class="other_details" *ngIf="status" [@fadeInAnimation]>

            <div class="the_card" id="print-section">
              <div class="row top_information">
                <div class="company col-md-8">
                  <h4 class="the__name">
                    <img src="assets/images/components/icons8-microsoft-excel-50.png" height="40px" alt="" class="company_logo">
                    UDSP - SOCIAL INVESTMENT MANAGEMENT SYSTEM
                  </h4>
                </div>
                <div class="real_time col-md-4">
                  <p class="the_time">
                    <span> {{date | date:'fullDate'}}</span>
                    <span >{{date | date:'h:mm:ss a'}}</span>
                  </p>
                </div>
              </div>

              <h4 class="the___top-heading" *ngIf="GMOUName">project detail report for {{GMOUName}}</h4>

              <div class="the__project-report-table" *ngIf="selectedProjects.length > 0">

                <div class="the___head" >
                  <span class="item">Project Category</span>
                  <span class="item">Project Type</span>
                  <span class="item">Project Name</span>
                  <span class="item">Vendor</span>
                  <span class="item">State</span>
                  <span class="item">LGA</span>
                  <span class="item" *ngIf="genericBlockLabel">{{genericBlockLabel}}</span>
                  <span class="item" *ngIf="genericFieldLabel">{{genericFieldLabel}}</span>
                  <span class="item">Budget</span>
                </div>
                <div class="the___head" *ngFor="let project of selectedProjects; index as i">
                  <span class="item">{{project.GMOUCategoryId}}</span>
                  <span class="item">{{project.GMOUTypeId}}</span>
                  <span class="item">{{project.ProjectTitle}}</span>
                  <span class="item">{{project.Executor}}</span>
                  <span class="item">
                    <span  *ngFor="let data of project?.States">
                      {{data?.StateName}}
                    </span>
                  </span>
                  <span class="item">
                    <span  *ngFor="let data of project?.Lgas">
                      {{data?.LgaName}}
                    </span>
                  </span>
                 <span class="item">
                  <span  *ngFor="let oilField of project?.OilFields">
                    {{oilField?.OilFieldName}}
                   </span>
                 </span>
                <span class="item">
                  <span  *ngFor="let oilBlock of project?.OilBlocks">
                    {{oilBlock?.OilBlockName}}
                  </span>
                </span>
                  <span class="item" *ngIf="project.Currency">{{project.Budget | currency:project.Currency:'symbol-narrow'}}</span>
                </div>

                <div class="grid_table-total" style="padding:0 0; margin:0; margin-top: 20px;">

                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span style="text-align: right; margin-right: 5px; font-weight: 700;">Total</span>
                  <span style="font-weight: 700;">{{totalAmount | currency:'NGN':'symbol-narrow'}}</span>

                  <span></span>
                  <span></span>
                </div>

              </div>
            </div>

            <div class="container" style="text-align: center; width:100%;">
              <button mat-raised-button class="top__btton mt-5 mb-5" [useExistingCss]="true"
              printSectionId="print-section"
              ngxPrint style="font-weight: 700;"><mat-icon class="example-tab-icon">print</mat-icon>  Print Report</button>
          </div>

        </div>


      </div>
</div>
</div>
</div>
</main>
</div>
